import { AppSelect, AppTag } from '@/components/atoms';
import type { CreateMassagerFormData } from '@/schemas/createMassagerSchema';
import { Col, Row } from 'antd';
import React from 'react';
import { Controller, type Control, type FieldErrors } from 'react-hook-form';

interface ClinicOption {
  id: number;
  clinic_number: string;
}

interface MassagerClinicSelectProps {
  control: Control<CreateMassagerFormData>;
  errors: FieldErrors<CreateMassagerFormData>;
  clinicOptions: ClinicOption[];
  fixedClinicId?: number | null;
}

export const MassagerClinicSelect: React.FC<MassagerClinicSelectProps> = ({
  control,
  errors,
  clinicOptions,
  fixedClinicId,
}) => {
  const isClinicFixed =
    fixedClinicId != null && fixedClinicId > 0 && clinicOptions.some(c => c.id === fixedClinicId);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <label className="mb-1 block font-medium">
          治療院名{' '}
          <AppTag color="magenta" className="ml-1">
            必須
          </AppTag>
        </label>
        <Controller
          name="clinic_id"
          control={control}
          render={({ field }) => (
            <AppSelect
              {...field}
              value={isClinicFixed ? (fixedClinicId ?? field.value) : field.value || undefined}
              onChange={v => field.onChange(v === undefined ? 0 : (v as number))}
              options={[
                ...clinicOptions.map(c => ({
                  value: c.id,
                  label: c.clinic_number,
                })),
              ]}
              status={errors.clinic_id ? 'error' : undefined}
              className="w-full"
              disabled={isClinicFixed}
            />
          )}
        />
        {errors.clinic_id && (
          <p className="mt-1 text-sm text-red-500">{errors.clinic_id.message}</p>
        )}
      </Col>
    </Row>
  );
};
